import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # SimpleProject
 *
 * SimpleProject을 설명하세요.
 */
export const SimpleProject = types
  .model('SimpleProject')
  // --------------------------------------------------------------------------
  .props({
    isSuccess: types.maybeNull(types.boolean),
    projectNm: types.maybeNull(types.optional(types.string, '')),
    projectSid: types.maybeNull(types.optional(types.number, 0)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model simpleProject --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ISimpleProject;
      (Object.keys(newProps) as TSimpleProjectKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TSimpleProject = Instance<typeof SimpleProject>;
type TSimpleProjectSnapshot = SnapshotOut<typeof SimpleProject>;

export interface ISimpleProject extends TSimpleProject {}
export type TSimpleProjectKeys = keyof TSimpleProjectSnapshot & string;
export interface ISimpleProjectSnapshot extends TSimpleProjectSnapshot {}
export const createSimpleProject = () => types.optional(SimpleProject, {} as TSimpleProject);
